<div class="d-flex flex-column flex-fill">
    <div class="d-flex flex-row m-2 align-items-baseline" style="gap: 10px">
        <div>End Date</div>
        <dx-date-box [(value)]="filter.endDate" style="max-width: 150px"></dx-date-box>
        <button type="button" accesskey="s" (click)="search()" class="btn btn-success" [disabled]="!filter.endDate">Search</button>
        <button type="button" (click)="clear()" class="btn btn-secondary">Clear</button>
    </div>

    <div class="d-flex flex-row flex-fill">
        <div *ngIf="orderLineDetails" [class]="showStackFlyout ? 'col-6' : 'col-12'" [ngStyle]="{ height: showAsDialog ? '600px' : '' }">
            <dx-data-grid
                #dataGrid
                [dataSource]="orderLineDetails"
                keyExpr="id"
                class="h-100 grid-fill"
                [columnAutoWidth]="false"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onOptionChanged)="onOptionChangedShared($event)"
                (onRowUpdating)="onRowUpdating($event)"
                (onRowUpdated)="onRowUpdated($event)"
                (onCellPrepared)="onCellPrepared($event)"
                (onExporting)="onExporting($event)"
                [customizeColumns]="customizeColumns"
            >
                <dxi-column width="60" [calculateSortValue]="sortByHotOrder" [allowSorting]="true" [sortIndex]="0" sortOrder="desc" cellTemplate="faTemplate"> </dxi-column>
                <dxi-column dataField="id" caption="Id" width="80"></dxi-column>
                <dxi-column dataField="scheduled"  width="100"  cellTemplate="scheduledTemplate"></dxi-column>
                <dxi-column dataField="isScheduled" width="100"></dxi-column>
                <dxi-column dataField="buildDue" caption="Prod. Due" width="100"></dxi-column>
                <dxi-column dataField="dueDate" caption="Ship Due" width="100"></dxi-column>
                <dxi-column dataField="status.name" caption="Status" width="100"></dxi-column>
                <dxi-column dataField="deliveryOption.name" caption="Delivery" width="100"></dxi-column>
                <dxi-column *ngIf="shippingMode" dataField="deliveryId" caption="Stack #" width="100" cellTemplate="deliveryTemplate"></dxi-column>
                <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="100" [sortIndex]="2" sortOrder="asc"></dxi-column>
                <dxi-column dataField="vIN" caption="Vin #" width="100"></dxi-column>
                <dxi-column dataField="vinEndingDisplay" caption="Vin Last 7" width="100"></dxi-column>
                <dxi-column width="100"></dxi-column>

                <dxi-column dataField="orderLine.order.invoiceNumber" caption="Order #" width="80" cellTemplate="linkTemplate" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="orderLine.order.pONumber" caption="PO #" width="80" cellTemplate="linkTemplate" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="orderLine.order.shippingNote" caption="ShippingNotes" width="80" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="orderLine.order.shipToCity" caption="City" width="100" [allowEditing]="false" cellTemplate="cityTemplate"></dxi-column>
                <dxi-column dataField="orderLine.order.shipToState" caption="State" width="45" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="false" width="65"></dxi-column>
                <dxi-column dataField="orderLine.partNumber" caption="Part #" width="125" [allowEditing]="false" cellTemplate="partNumberTemplate"></dxi-column>
                <dxi-column dataField="packingSlip.packingSlipNumber" caption="Slip #" width="125" [allowEditing]="false" cellTemplate="editTemplate"></dxi-column>
                <dxi-column dataField="packingSlip.invoiceNumber" caption="Invoice #" width="125" [allowEditing]="false" cellTemplate="printTemplate"></dxi-column>
                <dxi-column dataField="noteHTML" caption="Notes" width="550" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
                <dxi-column dataField="orderLine.order.createDate" caption="Order Date" width="100" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="confirmationApproved" caption="Confirmation" width="100" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="optionHTML" caption="Options" width="550" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
                <dxi-column dataField="orderLine.lineNumber" caption="Line No" width="100" [allowEditing]="false" [hidden]="!showAsDialog"></dxi-column>

                <!-- <dxi-column caption="Options" dataType="string" [calculateCellValue]="getHTMLOptions" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column> -->
                <div *dxTemplate="let item of 'faTemplate'" class="d-flex">
                    <i
                        *ngIf="(assemblyMode && item.data.buildPastDue) || (shippingMode && item.data.shipPastDue)"
                        class="fa fa-flag ms-2"
                        style="color: darkred"
                        title="Past Due"
                    ></i>
                    <i *ngIf="item.data.orderLine.order.achPayments.length > 0" class="fa fa-usd ml-2" style="color: #1b8600" title="Paid via ACH"></i>
                    <i *ngIf="item.data.hotOrder" class="fa fa-fire" style="color: red" title="Hot Order"></i>
                </div>

                <div *dxTemplate="let item of 'scheduledTemplate'">
                    <a [routerLink]="[]" (click)="openSchedulerBuilder(item.data.scheduled)">{{ item.data.scheduled | date: 'EEEE MM/dd/yyyy' }}</a>
                </div>

                <div *dxTemplate="let item of 'partNumberTemplate'">
                    <div title="{{ item.data.orderLine.description }}">{{ item.data.orderLine.partNumber }}</div>
                </div>
                <div *dxTemplate="let item of 'cityTemplate'">
                    <div [title]="item.data.shipAddressNotes || ''">{{ item.value }}</div>
                </div>
                <div *dxTemplate="let item of 'optionTemplate'">
                    <div style="font-weight: bold">{{ item.data.options }}</div>
                </div>
                <div *dxTemplate="let cell of 'editTemplate'">
                    <a [routerLink]="[]" (click)="editPackingSlip(cell.data)">{{ cell.value || '' }}</a>
                </div>
                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="'/sales-orders/' + cell.data.orderLine.order.id">{{ cell.value || '(blank)' }}</a>
                </div>
                <div *dxTemplate="let cell of 'printTemplate'">
                    <a [routerLink]="[]" (click)="printPDF(cell)">{{ cell.value || '' }}</a>
                </div>
                <div *dxTemplate="let cell of 'deliveryTemplate'">
                        <a [routerLink]="[]" (click)="editDelivery(cell.value)">{{ cell.value || '' }}</a>
                </div>

                <dxo-editing [mode]="'cell'" [allowUpdating]="false"></dxo-editing>
                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="gridStorageKey"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button *ngIf="showStackFlyout && !isFlyoutReadOnly" (click)="addToStack()" class="btn btn-sm btn-success me-2">Add</button>
                    <span *ngIf="!showStackFlyout">
                        <button [hidden]="!shippingMode || !canMakeDeliveries" (click)="generateStack()" class="btn btn-sm btn-success">Generate Stack</button>
                        <button [hidden]="true" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="toggleHotOrder()" class="btn btn-sm btn-warning ms-2">
                            Hot
                        </button>
                        <button
                            [hidden]="showAsDialog"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                            (click)="printBuildList()"
                            class="btn btn-sm btn-success ms-2"
                        >
                            {{ assemblyMode ? 'Build List' : 'Ship List' }}
                        </button>
                        <button
                            [hidden]="assemblyMode"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                            (click)="printPackList()"
                            class="btn btn-sm btn-secondary ms-1"
                        >
                            Print Packing Slip
                        </button>
                        <!-- <button
                        class="btn btn-sm btn-secondary ms-1"
                        (click)="printMsrp(dataGrid.instance.getSelectedRowsData())"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Print MSRP
                    </button> -->
                        <button
                            [hidden]="assemblyMode"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length == 0"
                            (click)="addToPackSlip()"
                            class="btn btn-sm btn-primary ms-2"
                        >
                            Add to Pack Slip
                        </button>
                        <button [hidden]="assemblyMode" [disabled]="!canRemoveFromPackSlip" (click)="removeFromPackSlip()" class="btn btn-sm btn-danger ms-2">
                            Remove From Pack Slip
                        </button>
                        <button
                            class="btn btn-sm btn-primary ms-4"
                            (click)="editOptions()"
                            [hidden]="true"
                            [disabled]="
                                dataGrid.instance.getSelectedRowsData().length !== 1 ||
                                !dataGrid.instance.getSelectedRowsData()[0].orderLine.partId ||
                                dataGrid.instance.getSelectedRowsData()[0].orderLine.isReplacement
                            "
                        >
                            Edit Options
                        </button>
                        <button
                            [hidden]="showAsDialog"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                            (click)="bulkUpdate()"
                            class="btn btn-sm btn-primary ms-1"
                        >
                            Bulk Update
                        </button>
                        <button
                            class="btn btn-sm btn-danger ms-3"
                            (click)="setStatusToBuilt()"
                            [hidden]="shippingMode"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !canSetBuilt"
                        >
                            Set Status to Built
                        </button>
                        <button [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="addNote()" class="btn btn-sm btn-success ms-4">Add Note</button>
                        <button [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="changeDueDate()" class="btn btn-sm btn-success ms-4">
                            Change Due Date
                        </button>

                        <!-- <button class="btn btn-sm btn-success ms-4" (click)="openSchedulerBuilder(dataGrid.instance.getSelectedRowsData()[0].scheduled)" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                            View Schedule Builder
                        </button> -->

                        <button class="btn btn-sm btn-danger ms-2" (click)="delete()" [hidden]="true" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                            Delete
                        </button>
                        <button class="btn btn-sm btn-danger ms-2" (click)="markAsNotBuilt()" [hidden]="true" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                            UnBuilt
                        </button>

                        <button *ngIf="hasChanges()" [hidden]="showAsDialog" type="button" (click)="save()" class="btn btn-sm btn-success ms-4">Save</button>
                    </span>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="orderLineDetails" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}</strong
                        ></span
                    >
                </div>
            </dx-data-grid>
        </div>

        <app-delivery-flyout
            #deliveryFlyout
            [delivery]="openedDelivery"
            [hidden]="!showStackFlyout"
            [readOnly]="isFlyoutReadOnly"
            (onCloseClick)="closeStack()"
            class="col-sm-6 d-flex flex-fill"
        ></app-delivery-flyout>
    </div>
</div>
